import React from "react";
import { NavLink } from "react-router-dom";
import { logout } from "../../services/oauthService";
import { Sparkles, HelpCircle } from "lucide-react";

const iconCls = "w-4 h-4 flex-shrink-0";

const SettingsIcon = () => (
  <svg className={iconCls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </svg>
);

const PanelIcon = () => (
  <svg className={iconCls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="7" height="7" />
    <rect x="14" y="3" width="7" height="7" />
    <rect x="14" y="14" width="7" height="7" />
    <rect x="3" y="14" width="7" height="7" />
  </svg>
);

const UsersIcon = () => (
  <svg className={iconCls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </svg>
);

const BriefcaseIcon = () => (
  <svg className={iconCls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <rect x="2" y="7" width="20" height="14" rx="2" ry="2" />
    <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" />
  </svg>
);

const LogOutIcon = () => (
  <svg className={iconCls} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </svg>
);

const groups = [
  {
    title: "Distribuição",
    items: [
      { label: "Configuração", to: "/home", icon: SettingsIcon },
      { label: "Painel", to: "/status", icon: PanelIcon },
      { label: "Nomes Cadastrados", to: "/nomes", icon: UsersIcon },
      { label: "Distribuições", to: "/distribuicoes", icon: BriefcaseIcon },
    ],
  },
];

export function Sidebar() {
  const handleLogout = () => {
    logout();
  };

  return (
    <aside className="w-64 flex flex-col border-r border-border bg-white flex-shrink-0">
      <nav className="flex-1 overflow-y-auto p-3">
        {groups.map((group) => (
          <div key={group.title} className="mb-4">
            <p className="mb-1.5 px-3 text-[0.7rem] font-bold uppercase tracking-widest text-muted-foreground">
              {group.title}
            </p>
            <ul className="flex flex-col gap-0.5 list-none m-0 p-0">
              {group.items.map((item) => (
                <li key={item.label}>
                  <NavLink
                    to={item.to}
                    className={({ isActive }) =>
                      `flex items-center gap-3 px-3 py-2 rounded-md text-sm transition-colors ${
                        isActive
                          ? "bg-primary/10 text-primary font-medium"
                          : "text-foreground hover:bg-accent"
                      }`
                    }
                  >
                    <item.icon />
                    <span>{item.label}</span>
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        ))}

        <div className="mt-4">
          <button
            className="flex items-center gap-3 w-full px-3 py-2 rounded-md text-sm text-foreground hover:bg-accent transition-colors"
            onClick={handleLogout}
          >
            <LogOutIcon />
            Sair
          </button>
        </div>
      </nav>

      <div className="border-t border-border p-3">
        <a
          href="https://novidades.projurisadv.com.br/pt"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-foreground hover:bg-accent transition-colors"
        >
          <Sparkles className="w-4 h-4" />
          Novidades
        </a>
        <a
          href="https://ajuda.projurisadv.com.br"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-3 rounded-md px-3 py-2 text-sm text-foreground hover:bg-accent transition-colors"
        >
          <HelpCircle className="w-4 h-4" />
          Central de Ajuda
        </a>
      </div>
    </aside>
  );
}
